module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/551aae506dfa65ce3b45713b5300a678.svg";